/**
 * 返回钮（21d-3）。此前每个详情页各写一遍 `‹ 返回`——25 处同样的四行 JSX，
 * 字形还是个字符（`‹` 的粗细/基线随系统字体走，和旧版 Material
 * `arrow_back_ios` 对不齐）。这里收口成一个组件 + 一个描边图标。
 *
 * 21ah-6（人工指图）：**只留箭头，不要「返回」二字**（旧版/iOS 原生同形），
 * 全站 30 处入口跟着这一个组件一起变。文案改走 `aria-label`——读屏与自动化
 * 还能按名字找到它，视觉上只剩一个尖角。
 *
 * `testid` 必传：各页既有的 e2e 全靠它点返回，名字沿用原来的（`about-back` 等），
 * 不统一成一个名字——统一反而要改 20 多个 spec，收益为零。
 */
import { IconChevronLeft } from './icons';
import styles from './backButton.module.scss';

export function BackButton({
  testid,
  onClick,
  disabled,
}: {
  testid: string;
  onClick: () => void;
  /** 提交在途时禁用（建群/邀请/公告三页原来就这么做） */
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      className={styles.back}
      data-testid={testid}
      aria-label="返回"
      disabled={disabled}
      onClick={onClick}
    >
      <IconChevronLeft class={styles.icon} />
    </button>
  );
}
